import { Claims } from '@core/authentication/claims';

export interface CountryOptions {
  name: Claims.Country;
}

export const DEFAULT_COUNTRY_OPTIONS: CountryOptions = {
  name: Claims.Country.Australia
};
